import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const SECTIONS = [
  {
    title: "1. Titolare del trattamento",
    body: `Il titolare del trattamento dei dati personali è il Dott. Matteo Caravetta, fisioterapista (P.IVA IT12985380018), contattabile all'indirizzo email mattec.fisio@gmail.com.`,
  },
  {
    title: "2. Dati raccolti",
    body: `Attraverso questo sito vengono raccolti i seguenti dati, forniti volontariamente dall'utente:

• Modulo di contatto: nome e cognome, numero di telefono, servizio richiesto e messaggio libero. Il messaggio può contenere informazioni relative allo stato di salute (dati particolari ai sensi dell'art. 9 GDPR).

• Recensioni: nome, età, valutazione in stelle e testo dell'esperienza. Le recensioni vengono pubblicate solo dopo approvazione del titolare.

• Dati di navigazione: il sito non utilizza cookie di profilazione né strumenti di tracciamento di terze parti. Vengono utilizzati esclusivamente cookie tecnici necessari al funzionamento dell'area riservata.`,
  },
  {
    title: "3. Finalità e base giuridica",
    body: `I dati sono trattati per:

• Rispondere alle richieste di contatto e fissare la prima valutazione (base giuridica: esecuzione di misure precontrattuali su richiesta dell'interessato, art. 6.1.b GDPR).

• Per i dati relativi alla salute contenuti nel messaggio: prestazione sanitaria richiesta dall'interessato (art. 9.2.h GDPR).

• Pubblicazione delle recensioni, solo previa approvazione (base giuridica: consenso dell'interessato, art. 6.1.a GDPR, espresso con l'invio volontario della recensione).`,
  },
  {
    title: "4. Modalità del trattamento e conservazione",
    body: `I dati sono trattati con strumenti informatici, con misure di sicurezza adeguate (accesso protetto da password, connessioni cifrate). Le richieste di contatto sono conservate per il tempo necessario a gestire la richiesta e, in caso di inizio del percorso terapeutico, secondo gli obblighi di legge in materia sanitaria. Le recensioni pubblicate restano visibili fino a eventuale richiesta di rimozione.`,
  },
  {
    title: "5. Comunicazione a terzi",
    body: `I dati non sono venduti né comunicati a terzi per finalità di marketing. Per il funzionamento tecnico del sito i dati transitano su infrastrutture del fornitore di hosting e sul servizio di invio email, che agiscono come responsabili del trattamento nel rispetto del GDPR.`,
  },
  {
    title: "6. Diritti dell'interessato",
    body: `In qualunque momento puoi esercitare i diritti previsti dagli artt. 15-22 GDPR: accesso ai tuoi dati, rettifica, cancellazione, limitazione del trattamento, opposizione e portabilità. Puoi inoltre revocare il consenso e proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).

Per esercitare i tuoi diritti o per qualsiasi domanda scrivi a mattec.fisio@gmail.com.`,
  },
  {
    title: "7. Modifiche a questa informativa",
    body: `Questa informativa può essere aggiornata nel tempo. La versione vigente è sempre quella pubblicata su questa pagina. Ultimo aggiornamento: ottobre 2026.`,
  },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-bone text-pine font-sans">
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-bone/85 border-b border-pine/10">
        <div className="max-w-4xl mx-auto px-6 h-[72px] flex items-center justify-between">
          <Logo />
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="text-xs uppercase tracking-[0.18em] text-moss hover:text-terracotta transition-colors duration-300"
          >
            ← Torna al sito
          </Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-16 lg:py-20">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-terracotta mb-4">Documento legale</p>
        <h1 className="font-serif tracking-tight text-3xl sm:text-4xl lg:text-5xl">Privacy Policy</h1>
        <p className="mt-6 text-base text-moss leading-relaxed max-w-2xl">
          Informativa sul trattamento dei dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR)
          per gli utenti del sito di Fisioterapia Dott. Caravetta Matteo.
        </p>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((s) => (
            <section key={s.title} data-testid={`privacy-section-${s.title.split(".")[0]}`}>
              <h2 className="font-serif text-2xl tracking-tight">{s.title}</h2>
              <p className="mt-4 text-sm lg:text-base text-moss leading-relaxed whitespace-pre-line">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
      <footer className="border-t border-pine/10 py-8">
        <p className="text-center text-xs text-moss">
          Dott. Matteo Caravetta — Fisioterapista · P.IVA IT12985380018
        </p>
      </footer>
    </div>
  );
}
